export const NEW_LEASE_AGREEMENT = 'new_lease_agreement'
export const LEASE_AGREEMENT_AMENDMENT = 'lease_agreement_amendment'
export const LEASE_TERMINATION_AGREEMENT = 'lease_termination_agreement'
export const OTHER_LEASE_DOCUMENTS = 'other_lease_documents'
export const POWER_OF_ATTORNEY = 'power_of_attorney'
export const OTHER = 'other'
export const HANDOVER_PROTOCOL = 'handover_protocol'
export const NOTICE = 'notice'
export const LEASE_TERMINATION_NOTICE = 'lease_termination_notice'

export const MAIN_LEASE_CONTRACT_TYPES = [
  NEW_LEASE_AGREEMENT,
  LEASE_AGREEMENT_AMENDMENT,
  LEASE_TERMINATION_AGREEMENT,
] as const
export type MainLeaseContractType = (typeof MAIN_LEASE_CONTRACT_TYPES)[number]

export const STANDARD_ADDITIONAL_LEASE_CONTRACT_TYPES = [
  POWER_OF_ATTORNEY,
  OTHER,
] as const

export const OTHER_REQUEST_ADDITIONAL_LEASE_CONTRACT_TYPES = [
  POWER_OF_ATTORNEY,
  HANDOVER_PROTOCOL,
  NOTICE,
  LEASE_TERMINATION_NOTICE,
  OTHER,
] as const

export const ALL_LEASE_CONTRACT_TYPES = [
  NEW_LEASE_AGREEMENT,
  LEASE_AGREEMENT_AMENDMENT,
  LEASE_TERMINATION_AGREEMENT,
  OTHER_LEASE_DOCUMENTS,
  POWER_OF_ATTORNEY,
  OTHER,
  HANDOVER_PROTOCOL,
  NOTICE,
  LEASE_TERMINATION_NOTICE,
] as const

export const ALL_OTHER_LEASE_CONTRACT_TYPES = [
  POWER_OF_ATTORNEY,
  OTHER,
  HANDOVER_PROTOCOL,
  NOTICE,
  LEASE_TERMINATION_NOTICE,
] as const

export type LeaseContractType = (typeof ALL_LEASE_CONTRACT_TYPES)[number]
export type OtherLeaseContractType =
  (typeof ALL_OTHER_LEASE_CONTRACT_TYPES)[number]
